"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _spauiUtils = require("@tencent/spaui-utils");

var _info = _interopRequireDefault(require("./info"));

var _drop_menu_compact_props = _interopRequireDefault(require("./drop_menu_compact_props"));

var _drop_menu_props = require("./drop_menu_props");

var _spauiIcon = _interopRequireDefault(require("@tencent/spaui-icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @class
 */
var DropMenu =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(DropMenu, _PureComponent);

  function DropMenu(props) {
    var _this;

    _classCallCheck(this, DropMenu);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DropMenu).call(this, props));
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(DropMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if ((0, _spauiUtils.isFunction)(_spauiUtils.checkCssVersion)) {
        (0, _spauiUtils.checkCssVersion)(_info["default"]);
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(event, name, clickValue) {
      var selected = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var disabled = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      var parentValue = arguments.length > 5 ? arguments[5] : undefined;
      var isGroupMultiple = arguments.length > 6 ? arguments[6] : undefined;
      var itemValue = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : {};

      var _compactProps = (0, _drop_menu_compact_props["default"])(this.props),
          _compactProps$value = _compactProps.value,
          value = _compactProps$value === void 0 ? {} : _compactProps$value,
          _compactProps$multipl = _compactProps.multiple,
          multiple = _compactProps$multipl === void 0 ? false : _compactProps$multipl,
          onChange = _compactProps.onChange,
          data = _compactProps.data,
          _compactProps$fieldNa = _compactProps.fieldNames,
          fieldNames = _compactProps$fieldNa === void 0 ? {} : _compactProps$fieldNa,
          handleOpen = _compactProps.handleOpen,
          closeAfterSelect = _compactProps.closeAfterSelect;

      var valueFieldName = fieldNames.valueFieldName,
          nodeFieldName = fieldNames.nodeFieldName,
          nameFieldName = fieldNames.nameFieldName;

      var getChildValueList = function getChildValueList() {
        var theParentValue = parentValue || clickValue;
        var result = [];
        var itemData = {};
        var list = [];
        var parentData = {};
        var childList = [];
        data.map(function (item) {
          if (item[nameFieldName] === name) {
            itemData = item;
          }

          return item;
        });
        list = itemData[nodeFieldName] || [];
        list.map(function (item) {
          if (item[valueFieldName] === theParentValue) {
            parentData = item;
          }

          return item;
        });

        if (parentData) {
          childList = parentData[nodeFieldName] || [];
          childList.map(function (item) {
            result.push(item[valueFieldName]);
            return item;
          });
        }

        return result;
      };

      var isSelectedAllChildren = function isSelectedAllChildren() {
        var itemData = {};
        var parentData = null;
        var list = [];
        var childList = [];
        var result = false;

        if (typeof parentValue !== 'undefined') {
          data.map(function (item) {
            if (item[nameFieldName] === name) {
              itemData = item;
            }

            return item;
          });
          list = itemData[nodeFieldName] || [];
          list.map(function (item) {
            if (item[valueFieldName] === parentValue) {
              parentData = item;
            }

            return item;
          });

          if (parentData) {
            childList = parentData[nodeFieldName] || [];

            if (childList.length > 0) {
              result = true;
              childList.map(function (item) {
                var itemValue = item[valueFieldName];

                if ((0, _spauiUtils.indexOf)(value[name] || [], itemValue) < 0 && itemValue !== clickValue) {
                  result = false;
                }

                return item;
              });
            }
          }
        }

        return result;
      };

      var result = {};
      var tempNameValue = [];
      var childValueList = getChildValueList();
      var key = '';
      var nameValue = '';
      var index = -1;

      if (!disabled && typeof clickValue !== 'undefined') {
        // 复制一下选中数据
        for (key in value) {
          if ((0, _spauiUtils.isArray)(value[key])) {
            result[key] = (0, _spauiUtils.cloneArray)(value[key]);
          } else {
            result[key] = value[key];
          }
        } // 多选时，可以指定每个组是否要使用多选


        if (multiple && typeof isGroupMultiple !== 'undefined' && !isGroupMultiple) {
          nameValue = [clickValue];
        } else if (multiple) {
          nameValue = result[name] || [];
          index = (0, _spauiUtils.indexOf)(nameValue, clickValue);

          if (selected) {
            if (typeof parentValue !== 'undefined' && (0, _spauiUtils.indexOf)(nameValue, parentValue) > -1) {
              nameValue.splice(index, 1);
              childValueList.map(function (item) {
                if (item !== clickValue) {
                  nameValue.push(item);
                }

                return item;
              });
            } else {
              nameValue.splice(index, 1); // 去掉子节点

              nameValue.map(function (item) {
                if ((0, _spauiUtils.indexOf)(childValueList, item) < 0) {
                  tempNameValue.push(item);
                }

                return item;
              });
              nameValue = tempNameValue;
            }
          } else {
            if (isSelectedAllChildren()) {
              nameValue.push(parentValue);
              nameValue.map(function (item) {
                if ((0, _spauiUtils.indexOf)(childValueList, item) < 0) {
                  tempNameValue.push(item);
                }

                return item;
              });
              nameValue = tempNameValue;
            } else {
              nameValue.push(clickValue);
            }
          }
        } else {
          nameValue = clickValue;
        }

        result[name] = nameValue;

        if ((0, _spauiUtils.isFunction)(onChange)) {
          onChange(event, result, itemValue);
        }

        if (closeAfterSelect) {
          handleOpen();
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _compactProps2 = (0, _drop_menu_compact_props["default"])(this.props),
          show = _compactProps2.show,
          _compactProps2$value = _compactProps2.value,
          value = _compactProps2$value === void 0 ? {} : _compactProps2$value,
          _compactProps2$data = _compactProps2.data,
          data = _compactProps2$data === void 0 ? [] : _compactProps2$data,
          _compactProps2$multip = _compactProps2.multiple,
          multiple = _compactProps2$multip === void 0 ? false : _compactProps2$multip,
          _compactProps2$disabl = _compactProps2.disabled,
          disabled = _compactProps2$disabl === void 0 ? false : _compactProps2$disabl,
          LinkComponent = _compactProps2.LinkComponent,
          _compactProps2$footer = _compactProps2.footer,
          footer = _compactProps2$footer === void 0 ? '' : _compactProps2$footer,
          _compactProps2$footer2 = _compactProps2.footerItemClassName,
          footerItemClassName = _compactProps2$footer2 === void 0 ? '' : _compactProps2$footer2,
          setItemClassName = _compactProps2.setItemClassName,
          _compactProps2$titleI = _compactProps2.titleItemClassName,
          titleItemClassName = _compactProps2$titleI === void 0 ? '' : _compactProps2$titleI,
          _compactProps2$titleC = _compactProps2.titleClassName,
          titleClassName = _compactProps2$titleC === void 0 ? '' : _compactProps2$titleC,
          _compactProps2$fieldN = _compactProps2.fieldNames,
          fieldNames = _compactProps2$fieldN === void 0 ? {} : _compactProps2$fieldN,
          title = _compactProps2.title,
          _compactProps2$preCon = _compactProps2.preContent,
          preContent = _compactProps2$preCon === void 0 ? '' : _compactProps2$preCon,
          _compactProps2$postCo = _compactProps2.postContent,
          postContent = _compactProps2$postCo === void 0 ? '' : _compactProps2$postCo,
          LinkComponentProps = _compactProps2.LinkComponentProps,
          width = _compactProps2.width;

      var valueFieldName = fieldNames.valueFieldName,
          labelFieldName = fieldNames.labelFieldName,
          nodeFieldName = fieldNames.nodeFieldName,
          titleFieldName = fieldNames.titleFieldName,
          nameFieldName = fieldNames.nameFieldName;
      var footerDom = null;

      if (typeof show !== 'undefined' && !show) {
        return null;
      } // 展示footer


      if (footer || typeof footer === 'number') {
        if (typeof footer === 'string' || typeof footer === 'number') {
          footerDom = _react["default"].createElement("li", {
            className: "spaui-menuitem spaui-menuitem-footer ".concat(footerItemClassName),
            dangerouslySetInnerHTML: {
              __html: footer
            }
          });
        } else {
          footerDom = _react["default"].createElement("li", {
            className: "spaui-menuitem spaui-menuitem-footer ".concat(footerItemClassName)
          }, footer);
        }
      }

      return _react["default"].createElement("div", _extends({}, (0, _spauiUtils.globalProps)(this.props, {
        className: (0, _classnames["default"])('spaui-dropmenu', {
          'custom-width': width
        }),
        events: ['onMouseOut', 'onMouseOver', 'onClick']
      }, DropMenu, this.props), {
        title: ""
      }), preContent, title ? _react["default"].createElement("div", {
        className: "spaui-submenu-title ".concat(titleClassName)
      }, title) : null, _react["default"].createElement("ul", {
        className: "spaui-submenu",
        style: {
          width: width
        }
      }, data.map(function () {
        var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var index = arguments.length > 1 ? arguments[1] : undefined;
        var name = item[nameFieldName] || '';
        var itemTitle = item[titleFieldName] || '';
        var list = item[nodeFieldName] || [];
        var nameValue = value[name];

        var isSelected = function isSelected(itemValue) {
          var result = false;

          if (typeof itemValue !== 'undefined') {
            if (multiple) {
              result = (0, _spauiUtils.indexOf)(nameValue, itemValue) > -1;
            } else {
              result = itemValue === nameValue;
            }
          }

          return result;
        };

        var result = [];
        var dividerDOM = null;

        if (index < data.length - 1) {
          dividerDOM = _react["default"].createElement("li", {
            key: "".concat(name + index, "divider"),
            className: "spaui-menuitem-divider"
          });
        }

        if (itemTitle) {
          result.push(_react["default"].createElement("li", {
            className: "spaui-submenu-head ".concat(titleItemClassName),
            key: "".concat(name + index, "title")
          }, itemTitle));
        }

        list.map(function () {
          var subItem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var subList = subItem[nodeFieldName] || [];
          var isDisabled = disabled || subItem.disabled || false; // 多选情况下，允许单独设置每组是否多选和单选

          var isGroupMultiple = multiple && typeof item.multiple !== 'undefined' ? item.multiple : multiple;

          if (typeof subItem[valueFieldName] !== 'undefined' || subList.length > 0) {
            result.push(_react["default"].createElement("li", {
              className: (0, _classnames["default"])('spaui-menuitem', {
                selected: isSelected(subItem[valueFieldName]),
                disabled: isDisabled,
                'has-submenu': subList.length > 0
              }, setItemClassName(subItem)),
              key: name + subItem[valueFieldName]
            }, _react["default"].createElement(LinkComponent, _extends({
              fieldNames: fieldNames,
              name: name,
              value: nameValue,
              data: subItem,
              className: (0, _classnames["default"])({
                'spaui-menu-title': subList.length > 0
              }),
              onClick: function onClick(event) {
                return _this2.handleClick(event, name, subItem[valueFieldName], isSelected(subItem[valueFieldName]), isDisabled, undefined, isGroupMultiple, subItem);
              }
            }, LinkComponentProps), isSelected(subItem[valueFieldName]) ? _react["default"].createElement(_spauiIcon["default"], {
              name: "check-bold-outlined",
              className: "spaui-menu-icon spaui-menu-icon-checkmark"
            }) : null, _react["default"].createElement("span", {
              className: "spaui-menu-text",
              title: typeof subItem[labelFieldName] === 'string' || subItem[labelFieldName] === 'number' ? subItem[labelFieldName] : ''
            }, subItem[labelFieldName]), subList.length > 0 ? _react["default"].createElement("i", {
              className: "spaui-menu-icon spaui-menu-arrow"
            }) : null), subList.length > 0 ? _react["default"].createElement("ul", {
              className: "spaui-submenu spaui-submenu-child"
            }, subList.map(function (child) {
              var childSelected = isSelected(subItem[valueFieldName]) || isSelected(child[valueFieldName]);
              var childDisabled = isDisabled || child.disabled || false;
              var isSubGroupMultiple = multiple && typeof subItem.multiple !== 'undefined' ? subItem.multiple : multiple;

              var onClickLinkComponent = function onClickLinkComponent(event) {
                _this2.handleClick(event, name, child[valueFieldName], childSelected, childDisabled, subItem[valueFieldName], isSubGroupMultiple, child);
              };

              return _react["default"].createElement("li", {
                key: child[valueFieldName],
                className: (0, _classnames["default"])('spaui-menuitem', {
                  selected: childSelected,
                  disabled: childDisabled
                }, setItemClassName(child))
              }, _react["default"].createElement(LinkComponent, _extends({
                fieldNames: fieldNames,
                name: name,
                value: nameValue,
                data: child,
                onClick: onClickLinkComponent
              }, LinkComponentProps), childSelected ? _react["default"].createElement("i", {
                className: "spaui-menu-icon spaui-menu-icon-checkmark"
              }) : null, _react["default"].createElement("span", {
                className: "spaui-menu-text"
              }, child[fieldNames.labelFieldName])));
            })) : null));
          }
        });
        result.push(dividerDOM);
        return result;
      }), footerDom ? _react["default"].createElement("li", {
        className: "spaui-menuitem-divider"
      }) : null, footerDom), postContent);
    }
  }]);

  return DropMenu;
}(_react.PureComponent); // 组件标记


_defineProperty(DropMenu, "propTypes", _drop_menu_props.propTypes);

_defineProperty(DropMenu, "defaultProps", _drop_menu_props.defaultProps);

(0, _spauiUtils.setComponentMark)(DropMenu, _info["default"]); // 组件上报

(0, _spauiUtils.reportComponentUsage)(_objectSpread({
  scope: 'spaui'
}, _info["default"])); // 用于 focus 样式只在键盘索引时生效，而在鼠标操作时不生效

(0, _spauiUtils.initFocusManager)('spaui-focus-disabled');
var _default = DropMenu;
exports["default"] = _default;